/**
 * Largo del código de verificación que envía Supabase. Lo decide `mailer_otp_length` del proyecto, y
 * vive en un solo sitio para que ninguna pantalla suponga otro largo.
 */
export const LARGO_CODIGO = 8;
